import {
  ListMultiServiceAvailabilityTimeSlotsRequest,
  ListMultiServiceAvailabilityTimeSlotsResponse,
} from '@wix/ambassador-bookings-availability-v2-time-slot/types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { listMultiServiceAvailabilityTimeSlots as listMultiServiceAvailabilityTimeSlotHttpRequest } from '@wix/ambassador-bookings-availability-v2-time-slot/http';
import {
  panoramaQueryAvailabilityInteractionStart,
  panoramaQueryAvailabilityInteractionEnd,
} from '../../utils/panorama/panorama';
import { PanoramaTransactions } from '../../utils/panorama/consts';

export const listMultiServiceAvailabilityTimeSlots = async (
  listMultiServiceAvailabilityTimeSlotRequest: ListMultiServiceAvailabilityTimeSlotsRequest,
  flowAPI: ControllerFlowAPI,
): Promise<ListMultiServiceAvailabilityTimeSlotsResponse> => {
  await panoramaQueryAvailabilityInteractionStart({
    flowAPI,
    request: listMultiServiceAvailabilityTimeSlotRequest,
    transaction: PanoramaTransactions.availabilityTimeSlotsMultiService,
  });

  try {
    const response = (
      await flowAPI.httpClient.request(
        listMultiServiceAvailabilityTimeSlotHttpRequest(
          listMultiServiceAvailabilityTimeSlotRequest,
        ),
      )
    ).data;

    await panoramaQueryAvailabilityInteractionEnd({
      flowAPI,
      response,
      transaction: PanoramaTransactions.availabilityTimeSlotsMultiService,
      request: listMultiServiceAvailabilityTimeSlotRequest,
    });

    return response;
  } catch (e) {
    throw e;
  }
};